module.exports = __webpack_public_path__ + "6b8a97732e78b4ad67e72bd927b7bbaf.svg";